export default "__VITE_ASSET__wgOhCYFA__"